export default __webpack_public_path__ + "static/media/gerjan.59902147.png";